module.exports = __webpack_public_path__ + "static/img/empty-product-collect.0724026c.png";